const defaultState = {
  country: '',
  localState: 'Abia',
  localArea: '',
  propertyType: 'Real Estate',
  purchaseOption: 'Buy',
  categoryType: 'HouseHolds',
  listingType: '',
  propertyPrice: 0,
  selectedListing: {},
  searchModalDisplay: false,
  listingID: '',
};

export default (state = defaultState, action) => {
  switch(action.type){
    case 'SET_COUNTRY_FILTER_SEARCH':
      return {
        ...state,
        country: action.country,
      }
    case 'SET_STATE_FILTER_SEARCH':
      return {
        ...state,
        localState: action.localState,
      }
    case 'SET_AREA_FILTER_SEARCH':
      return {
        ...state,
        localArea: action.localArea,
      }
    case 'SET_PROPERTY_TYPE_FILTER_SEARCH':
      return {
        ...state,
        propertyType: action.propertyType,
      }
    case 'SET_PURCHASE_OPTION_FILTER_SEARCH':
      return {
        ...state,
        purchaseOption: action.purchaseOption,
      }
    case 'SET_CATEGORY_FILTER_SEARCH':
      return {
        ...state,
        categoryType: action.categoryType,
      }
    case 'SET_LISTING_SEARCH':
      return {
        ...state,
        listingType: action.listingType,
      }
    case 'SET_PROPERTY_PRICE_FILTER_SEARCH':
      return {
        ...state,
        propertyPrice: action.propertyPrice,
      }
    case 'SET_SELECTED_LISTING':
      return {
        ...state,
        selectedListing: action.selectedListing,
      }
    case 'SET_CURRENT_FILTERED_LISTING':
      return {
        ...state,
        currentFilteredListings: action.currentFilteredListings,
      }
    case 'SET_SEARCH_MODAL_DISPLAY':
      return {
        ...state,
        searchModalDisplay: action.searchModalDisplay,
      }
    case 'SET_LISTING_ID':
      return {
        ...state,
        listingID: action.listingID,
      }
    default:
      return state;
  };
};
